import React, {SyntheticEvent} from 'react';

export function cloneEventWithNewValue<T extends SyntheticEvent<unknown>>(event: T, value: string): T {
	return {
		...event,
		target: {
			...event.target,
			value,
		},
	};
}

export const withEventBehaviourOmitted =
	<T extends React.SyntheticEvent>(fn: (e: T) => any) =>
	(e: T) => {
		omitEventDefaultBehavior(e);
		return fn(e);
	};

export const omitEventDefaultBehavior = <T extends React.SyntheticEvent>(event: T): void => {
	event.stopPropagation();
	event.preventDefault();
};
